import useMods from '@hooks/useMods';
import css from '@utils/css';

import NextLink from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';

const Link = ({ children, mods={}, mix, href, target, onClick, className: classNameTail, linkProps }) => {
  const { className } = useMods(Link, { mix, mods });

  return (
    <NextLink
      href={ href }
      prefetch={ false }
      onClick={ onClick }
      className={ css(className, classNameTail) }
      target={ target }
      { ...linkProps }>
      { /* eslint-disable-next-line jsx-a11y/anchor-is-valid */ }

      { children }

    </NextLink>
  );
};

Link.displayName = 'Link';

Link.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string,
  mix: PropTypes.object,
  mods: PropTypes.object,
  onClick: PropTypes.func,
  target: PropTypes.string
};

export default Link;
